export default {
  back: 'Terug',
  next: 'Verder'
};
